import { createContext } from 'react';
export const RouteContext = createContext({});

export const LinesDataContext = createContext({ linesData: [], filledLines: 0 });
